import React from 'react';

const GlobalSidebar = ({ children }) => (
  <div className="ps-3 pt-3" style={{ minWidth: '400px', maxWidth: '400px', border: '1px solid #202832' }}>
    {children}
  </div>
);

export default GlobalSidebar;
